export enum CookieName {
    ShopperToken = 'shopper-token',
    ShopperRefreshToken = 'shopper-refresh-token',
    ShopperRefreshExtendedToken = 'shopper-refresh-token-extended',
    DWSID = 'dwsid',
    FavoriteStore = 'favStore',
    SelectedDeliveryStore = 'estoreSelectedStore',
    RedirectLocale = 'redirectLocale',
    ShopTheFutureContext = 'shop-the-future-context',
    GuestWishlistProductId = 'guestWishlistedProduct',
    ColorSetting = 'colorSetting',
    PotionGuestId = 'potion_guest_id',
    Reco = 'reco',
}
